import { Component, OnInit, ɵConsole } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-mppt-data',
  templateUrl: './mppt-data.component.html',
  styleUrls: ['./mppt-data.component.scss']
})
export class MpptDataComponent implements OnInit {
  private ResponseVerifiedMpptData: Subject<any> = new Subject();
  private ResponseVerifiedInverterList: Subject<any> = new Subject();
  private ResponseVerifiedwmsInverterList: Subject<any> = new Subject();
  private ResponseWmsMpptData: Subject<any> = new Subject();

  role: any;
  roleName: string;
  mpptDataDetailsArray: any = [];
  wmsMpptDataDetailsArray: any = [];
  mpptStringDataArray: any;
  page = 1;
  public inverterform: FormGroup;
  public wmsinverterform: FormGroup;
  inverterDetails_id: any;
  public inverterList: any = [];
  public wmsInverterList: any = [];
  public serial_no: any;
  public subDevice_id: any;
  public wmsSubDevice_id: any;
  inverterObj: any;
  constructor(private router: Router, private dashboardService: DashboardService,
              private toastr: ToastrService, private fb: FormBuilder) {
    this.role = localStorage.role;
    if (this.role === '1') {
      this.roleName = 'admin';
    } else if (this.role === '2') {
      this.roleName = 'epc';
    } else if (this.role === '3') {
      this.roleName = 'wms';
    } else if (this.role === '4') {
      this.roleName = 'normal';
    }
    else if (this.role === '6') {
      this.roleName = 'ze';
    }else if (this.role === '7') {
      this.roleName = 'dg';
    }
  }


  ngOnInit() {
    this.inverterform = this.fb.group({
      inverter_id: [null, Validators.required],
    });
    this.wmsinverterform = this.fb.group({
      wmsinverter_id: [null, Validators.required],
    });
    if (this.roleName === 'normal') {
      this.getNormalInverterList();
    }
    if (this.roleName === 'wms') {
      this.getWmsInverterList();

    }
    if (this.roleName === 'ze'||this.roleName === 'dg') {
      this.getZeDgInverterList();

    }
  }

// onchange normal user inverter
  onChange(value) {
    this.subDevice_id = value;
    this.getMpptData();
  }

  onChangeWmsInv(value) {
    this.wmsSubDevice_id = value;
    this.getWmsMpptData();
  }

  onChangeZeDgInv(value) {
    this.wmsSubDevice_id = value;
    this.getZeDgMpptData();
  }

  // get normal user inverter list on drop Down
  public getNormalInverterList() {

    this.dashboardService.getInverterList()
      .pipe(takeUntil(this.ResponseVerifiedInverterList))
      .subscribe(
        async result => {
          if (result.status) {           
            // result.resultObject.splice(result.resultObject.findIndex(value => value.sub_device_id != '1') , 1)
            // this.inverterList = result.resultObject;

            for (let index = 0; index < result.resultObject.length; index++) {
              if(result.resultObject[index]['sub_device_type_id'] == '1' || result.resultObject[index]['sub_device_type_id'] == 1){
                this.inverterList.push(result.resultObject[index]);
              }
            }
 
            //  console.log(this.inverterList);
            // this.subDevice_id = this.inverterList[0].id;

            this.subDevice_id = this.inverterList[0].id;

            this.inverterform.get('inverter_id').setValue(this.subDevice_id);
            this.getMpptData();

          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

   // get wms user inverter list on drop Down
  public getWmsInverterList() {

    this.dashboardService.getWmsInverterList()
      .pipe(takeUntil(this.ResponseVerifiedwmsInverterList))
      .subscribe(
        async result => {
          this.wmsInverterList = [];
          if (result.status) {
            for (let index = 0; index < result.resultObject.length; index++) {
              if(result.resultObject[index]['sub_device_type_id'] == '1' || result.resultObject[index]['sub_device_type_id'] == 1){
                this.wmsInverterList.push(result.resultObject[index]);
              }
            }
            //  this.wmsInverterList = result.resultObject;
            this.wmsSubDevice_id = this.wmsInverterList[0].id;
            this.wmsinverterform.get('wmsinverter_id').setValue(this.wmsSubDevice_id);
            this.getWmsMpptData();
          } else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
// get ze dg user inverter list on drop Down
  public getZeDgInverterList() {

  this.dashboardService.getZeDgInverterList()
    .pipe(takeUntil(this.ResponseVerifiedwmsInverterList))
    .subscribe(
      async result => {
        this.wmsInverterList = [];
        if (result.status) {
          for (let index = 0; index < result.resultObject.length; index++) {
            if(result.resultObject[index]['sub_device_type_id'] == '1' || result.resultObject[index]['sub_device_type_id'] == 1){
              this.wmsInverterList.push(result.resultObject[index]);
            }
          }
          // this.wmsInverterList = result.resultObject;
          this.wmsSubDevice_id = this.wmsInverterList[0].id;
          this.wmsinverterform.get('wmsinverter_id').setValue(this.wmsSubDevice_id);
          this.getZeDgMpptData();
        } else if (!result.status) {
          if (result.message === 'Unauthorised or Login Time-out') {
            this.toastr.info(result.message);
            this.router.navigate(['/login']);

          } else {
            this.toastr.info(result.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
  }

   // get Mppt&&String Data for normal user
  public getMpptData() {
  const sub_device_id = this.inverterList.find(x => x.id ===  this.inverterform.value.inverter_id).sub_device_id;
   var inverterObj = {
     sub_device_id:sub_device_id,
     inv_id: this.inverterform.value.inverter_id
   };

  this.dashboardService.getmpptData(inverterObj)
    .pipe(takeUntil(this.ResponseVerifiedMpptData))
    .subscribe(
      async result => {
        this.mpptDataDetailsArray = [];
        if (result.status) {
          this.mpptDataDetailsArray = result.resultObject;

        }  else if (!result.status) {
          if (result.message === 'Unauthorised or Login Time-out') {
            this.toastr.info(result.message);
            this.router.navigate(['/login']);

          } else {
            this.toastr.info(result.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
    }

  // get wms user mmpt and string data
  public getWmsMpptData() {
   // tslint:disable-next-line:variable-name
   const sub_device_id = this.wmsInverterList.find(x => x.id == this.wmsinverterform.value.wmsinverter_id).sub_device_id;
   this.inverterObj = {
      sub_device_id:sub_device_id,
      inv_id: this.wmsinverterform.value.wmsinverter_id
    };
   this.dashboardService.getWmsmpptData(this.inverterObj)
      .pipe(takeUntil(this.ResponseWmsMpptData))
      .subscribe(
        async result => {
          this.wmsMpptDataDetailsArray = [];
          if (result.status) {
            this.wmsMpptDataDetailsArray = result.resultObject;
            }  else if (!result.status) {
            if (result.message === 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(['/login']);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
   }

  // get ze user mmpt and string data
  public getZeDgMpptData() {
  // tslint:disable-next-line:variable-name
  const sub_device_id = this.wmsInverterList.find(x => x.id == this.wmsinverterform.value.wmsinverter_id).sub_device_id;
  this.inverterObj = {
     sub_device_id:sub_device_id,
     inv_id: this.wmsinverterform.value.wmsinverter_id
   };
  this.dashboardService.getZeDgmpptData(this.inverterObj)
     .pipe(takeUntil(this.ResponseWmsMpptData))
     .subscribe(
       async result => {
         this.wmsMpptDataDetailsArray = [];
         if (result.status) {
           this.wmsMpptDataDetailsArray = result.resultObject;
        console.log("2 nd table data")
        console.log(this.wmsMpptDataDetailsArray);
           }  else if (!result.status) {
           if (result.message === 'Unauthorised or Login Time-out') {
             this.toastr.info(result.message);
             this.router.navigate(['/login']);

           } else {
             this.toastr.info(result.message);

           }

         }
       },
       err => {
         return console.error(err);
       }
     );
  }


  ngOnDestroy() {
    this.ResponseVerifiedMpptData.next();
    this.ResponseVerifiedMpptData.complete();

    this.ResponseVerifiedInverterList.next();
    this.ResponseVerifiedInverterList.complete();

    this.ResponseVerifiedwmsInverterList.next();
    this.ResponseVerifiedwmsInverterList.complete();

    this.ResponseWmsMpptData.next();
    this.ResponseWmsMpptData.complete();
  }
}
